// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1_k7z","cls2":"BulkFollowSuggestion-cls2__F0 BulkFollowSuggestion-cls1_k7z"};